import type { RuleConditionsStep } from "@redotech/redo-flows-common/rules/schemas";
import { useTranslation } from "@redotech/redo-i18n";
import BranchIcon from "@redotech/redo-icons/git-branch-01.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import type { PartialFlowStep, PartialWithRequiredType } from "../../steps";
import { BaseNode } from "../base-node";
import * as NodeCSS from "../node.module.css";
import { getRuleConditionsSummary } from "./rule-node-summary";
import { RuleNodeSummaryText } from "./rule-node-summary-text";

export interface RuleConditionsNodeData {
  step: PartialWithRequiredType<RuleConditionsStep>;
  deleteElements: (id: string) => void;
  updateStep: (id: string, updatedStep: PartialFlowStep) => void;
  readonly: boolean;
  hovered?: boolean;
}

export const RuleConditionsNode = memo(function RuleConditionsNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: RuleConditionsNodeData;
  selected?: boolean;
}) {
  const { t } = useTranslation();
  const summary = getRuleConditionsSummary(data.step.conditionGroups);

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        hovered={data.hovered}
        icon={
          <RedoFeaturedIcon
            color="warning"
            Icon={BranchIcon}
            shape="circle"
            size="xs"
          />
        }
        onDelete={() => data.deleteElements(id)}
        selected={selected}
        step={data.step}
        title={t("Condition")}
      >
        <Flex className={NodeCSS.fullInput} dir="column" gap="none">
          <RuleNodeSummaryText summary={summary} />
        </Flex>
        <Handle
          className={NodeCSS.edgeHandle}
          id="a"
          position={Position.Bottom}
          type="source"
        />
        <Handle
          className={NodeCSS.edgeHandle}
          id="b"
          position={Position.Bottom}
          type="source"
        />
      </BaseNode>
    </>
  );
});
